export const LABEL_VALUES_LABELS = {
	SECTION_TITLE: 'Label values',
	ADD_SUBSECTION_TITLE: 'Add values',
	ADD_SUBSECTION_SUBTITLE: 'Create values individually or upload a file to add them in bulk.',
	ADD_VALUE_LABEL: 'Enter new value',
	ADD_VALUE_PLACEHOLDER: 'Enter new value',
	ADD_VALUE_BUTTON: 'Add',
	UPLOAD_VALUES_BUTTON: 'Upload Values',
	UPLOAD_VALUES_INPUT_ARIA: 'Upload label values from a CSV file',
	EXISTING_SUBSECTION_TITLE: 'Existing values',
	EMPTY_STATE: 'No values added yet',
	UPLOAD_FILE_READ_ERROR: 'Could not read the file. Please try again.',
	UPLOAD_INVALID_FILE_TYPE: 'Invalid file type. Please upload a .csv file.',
	UPLOAD_FILE_TOO_LARGE: 'File exceeds the 1 MB size limit. Please upload a smaller file.',
	UPLOAD_EMPTY_FILE: 'The uploaded file contains no values.',
	UPLOAD_INVALID_CSV_BANNER: "We couldn't upload your file because it contains errors",
	UPLOAD_INVALID_CSV_DOWNLOAD: 'Download',
	CSV_ERROR_BANNER_ARIA: 'Label values CSV upload error',
	CSV_UPLOAD_TOAST_ADDED: (added: number, skipped: number): string =>
		`Added ${added} value(s). Skipped ${skipped} duplicate row(s).`,
	CSV_UPLOAD_TOAST_ALL_DUPLICATES: (skipped: number): string =>
		`No new values added. ${skipped} duplicate row(s) skipped.`,
	CSV_ERROR_REPORT_VALUE_COLUMN: 'Value',
	CSV_ERROR_REPORT_STATUS_COLUMN: 'Status',
	CSV_ERROR_REPORT_STATUS_INVALID: 'Invalid',
	CSV_ERROR_REPORT_STATUS_OK: 'OK'
} as const;

export const LABEL_VALUES_CSV_ERROR_REPORT_FILENAME = 'label-values-upload-report.csv' as const;
